import { apiFailureCase } from '../../../../utils/reduxOperations';
export function getUserProfileFailed(state, payload) {
    return{
        ...state,
        getUserProfileApi:
        apiFailureCase(state.getUserProfileApi,payload)
    };
}
